module.exports = __webpack_public_path__ + "img/noimage.af01d7d3.jpg";